import { loadModules } from 'esri-loader';
import GeometryHelper from '../helpers/GeometryHelper';

export default class ClientsideFacilities {
  constructor(props) {
    this.props = props;
  }

  async getFacilities(featureLayer) {
    const [Query] = await loadModules(['esri/tasks/support/Query']);
    const query = new Query();
    query.where = this.props.where;
    query.returnDistinctValues = true;
    query.returnGeometry = false;
    query.outFields = new Array(
      this.props.nameField,
      this.props.stateField,
      this.props.countryField
    );

    const response = await featureLayer.queryFeatures(query);
    const facilityData =
      response.features && response.features.length > 0
        ? response.features.map((f) => {
          return {
            name: f.attributes[this.props.nameField],
            state: f.attributes[this.props.stateField],
            country: f.attributes[this.props.countryField]
          };
        })
        : null;
    return facilityData;
  }

  async getStatusValues(featureLayer) {
    const [Query] = await loadModules(['esri/tasks/support/Query']);
    const query = new Query();
    query.where = this.props.statusTypeWhere;
    query.returnDistinctValues = true;
    query.returnGeometry = false;
    query.outFields = new Array(this.props.statusTypeField);

    const response = await featureLayer.queryFeatures(query);
    const statusData =
      response.features && response.features.length > 0
        ? response.features.map((f) => {
          return {
            status: f.attributes[this.props.statusTypeField]
          };
        })
        : null;
    return statusData;
  }

  async getContinentalUsaFacilitiesExtent(featureLayer) {
    const where = `LOWER(${this.props.countryField}) = LOWER('${this.props.usaCountryValue}') AND LOWER(${this.props.stateField}) <> LOWER('${this.props.hawaiiStateValue}')`;
    console.log(`USA: ${where}`);
    return this._getFacilitiesExtent(
      featureLayer,
      where,
      this.props.usaExtentExpandFactor
    );
  }

  async getContinentalNorthAmericaFacilitiesExtent(featureLayer) {
    const where = `(LOWER(${this.props.countryField}) = LOWER('${this.props.usaCountryValue}') AND LOWER(${this.props.stateField}) <> LOWER('${this.props.hawaiiStateValue}')) OR LOWER(${this.props.countryField}) = LOWER('${this.props.canadaCountryValue}')`;
    console.log(`NA: ${where}`);
    return this._getFacilitiesExtent(
      featureLayer,
      where,
      this.props.globalExtentExpandFactor
    );
  }

  async getCanadaFacilitiesExtent(featureLayer) {
    const where = `LOWER(${this.props.countryField}) = LOWER('${this.props.canadaCountryValue}')`;
    console.log(`CA: ${where}`);
    return this._getFacilitiesExtent(
      featureLayer,
      where,
      this.props.canadaExtentExpandFactor
    );
  }

  async _getFacilitiesExtent(featureLayer, where, extentExpandFactor) {
    const [Query] = await loadModules(['esri/tasks/support/Query']);

    const query = new Query();
    query.where = where;
    query.returnGeometry = true;
    const response = await featureLayer.queryFeatures(query);

    const extent = await GeometryHelper.getExtentOfAllFeatures(
      response.features
    );
    extent.expand(extentExpandFactor);
    return response && response.features ? extent : null;
  }

  async getFacilityInfoByName(
    featureLayer,
    name,
    imageLinkField,
    factsheetLinkField,
    techType,
    factSheetFactoids,
    facilityFields,
    leftPanel
  ) {
    const [Query] = await loadModules(['esri/tasks/support/Query']);

    const query = new Query();
    query.where = `LOWER(${this.props.nameField}) = LOWER('${name}')`;
    query.returnGeometry = true;
    const outFields = new Array(
      this.props.nameField,
      imageLinkField,
      factsheetLinkField
    );
    // if (factoids) {
    //   factoids.forEach((f) => {
    //     outFields.push(f.field);
    //   });
    // }
    if (factSheetFactoids) {
      for (var k in factSheetFactoids) {
        const f = factSheetFactoids[k];
        f.forEach((a) => {
          a.args.forEach((arg) => {
            outFields.push(arg);
          });
        });
      }
    }
    if (facilityFields) {
      facilityFields.forEach((f) => {
        outFields.push(f);
      });
    }
    query.outFields = outFields;

    const response = await featureLayer.queryFeatures(query);
    // if (factSheetFactoids && !factoids) {
    //   return response.features[0].attributes;
    // }

    const getValue = (value) => response.features[0].attributes[value];

    const getFactoids = (facts) => {
      if (facts) {
        const parse = (str, args) => {
          try {
            var v = str;
            args.forEach((a) => {
              v = (a && a !== null)
                ? v.replace('%s', a)
                : v.replace('%s', '')
            });
            return v;
          } catch (ex) {
            return;
          }
        };
        return facts.map((fact) => {
          const calculatedValue = (fact) => {
            const valueArgs = [];
            fact.args.forEach((a) => {
              valueArgs.push(getValue(a));
            });
            let v;
            valueArgs.indexOf(null) !== -1 && fact.altValue
              ? v = parse(fact.altValue, valueArgs)
              : v = parse(fact.value, valueArgs)
            return v;
          };
          return {
            label: fact.label,
            value: calculatedValue(fact)
          };
        });
      }
    };
    // Use the first feature found by name (implicit assumption that name is unique)
    const resultValue = response.features
      ? response.features[0].attributes[this.props.nameField]
      : null;
    const imageLinkValue =
      response.features && response.features[0].attributes[imageLinkField]
        ? response.features[0].attributes[imageLinkField]
        : '';
    const factsheetLinkValue =
      response.features && response.features[0].attributes[factsheetLinkField]
        ? response.features[0].attributes[factsheetLinkField]
        : '';
    const facilityTech = response.features[0].attributes[techType];
    const facts = facilityTech !== null && factSheetFactoids[facilityTech]
      ? factSheetFactoids[facilityTech]
      : factSheetFactoids['default'];
    const updatedFactoids = getFactoids(facts);

    let disclaimer;
    if (leftPanel) {
      const headerFacts = factSheetFactoids["leftPanelHeaders"];
      getFactoids(headerFacts).reverse().map((f) => updatedFactoids.unshift(f));
      const footerFacts = factSheetFactoids["leftPanelFooters"];
      getFactoids(footerFacts).map((f) => updatedFactoids.push(f));
      const disclaimerFacts = factSheetFactoids["disclaimer"];
      const disclaimers = getFactoids(disclaimerFacts);
      if (disclaimers && disclaimers.length > 0) {
        disclaimer = disclaimers[0].value ? disclaimers[0].value : undefined;
      }
    }

    const cleanedFactoids = updatedFactoids.filter((fact) => { return (fact.label !== "" && fact.value && fact.value.length > 0) });

    //const cleanInvalidWebsites = cleanedFactoids.filter((fact) => { return (fact.value !== "<a href='https://'></a>") });

    const resultExtent = await GeometryHelper.getExtentOfAllFeatures(
      response.features
    );
    resultExtent.expand(this.props.facilityExtentExpandFactor);
    return resultValue
      ? {
        name: resultValue,
        imageLink: imageLinkValue,
        factsheetLink: factsheetLinkValue,
        updatedFactoids: cleanedFactoids,
        disclaimer,
        extent: resultExtent,
        attributes: response.features[0].attributes
      }
      : null;
  }

  async getFacilityNameByGeometry(featureLayer, mapPoint, currentFilter) {
    const [Query] = await loadModules(['esri/tasks/support/Query']);
    const query = new Query();

    query.where = currentFilter;
    query.returnGeometry = false;
    query.geometry = mapPoint;
    query.outFields = new Array(this.props.nameField);

    const response = await featureLayer.queryFeatures(query);
    return response.features && response.features.length > 0
      ? response.features[0].attributes[this.props.nameField]
      : null;
  }

  async getFacilityTableData(featureLayer) {
    const [Query] = await loadModules(['esri/tasks/support/Query']);
    const query = new Query();
    query.where = '1=1';
    const outfields = [];
    for (const field in this.props.facilityTableDataFields) {
      outfields.push(this.props.facilityTableDataFields[field]);
    }
    query.outFields = outfields;

    const response = await featureLayer.queryFeatures(query);
    return response.features && response.features.length > 0
      ? response.features
      : null;
  }

  async sortFacilityTableData(projects, assetTypes) {
    if (projects && assetTypes) {
      const projectObj = projects.map((item) => {
        const data = {};
        for (var tableDataMap in this.props.facilityTableDataFields) {
          const attr = this.props.facilityTableDataFields[tableDataMap];
          data[tableDataMap] = item.attributes[attr];
        }
        return data;
      });
      const tableData = {};
      for (var asset in assetTypes) {
        const assetType = assetTypes[asset];
        const assetValue =
          assetType.value && assetType.value.indexOf('Null') === -1
            ? assetType.value
            : null;
        tableData[assetType.label] = projectObj.filter(
          (f) => f.asset == assetValue
        );
      }
      return tableData;
    }
    return null;
  }
}
